import { styled } from '@mui/material/styles';
import { shouldForwardProp as muiShouldOverrideProp } from '@mui/system/createStyled';

// we should reduce the container size because the anchor has an almost invisible border
// so it might seem like the container is bigger than the anchor.
const anchorBorderSize = 2;

export const BaseSelectMenuRoot = styled('div', {
  shouldForwardProp: prop =>
    prop !== 'width' && prop !== 'size' && muiShouldOverrideProp(prop)
})(({ theme, size, width }) => ({
  outline: 'none',
  border: 'none',
  ...(size && {
    width: size === 'fullWidth' && width ? width - anchorBorderSize : null,
    minWidth:
      size === 'fullWidth' && width
        ? null
        : theme.sizes?.selectMenu[size] - anchorBorderSize
  })
}));

export const SearchContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  borderBottom: `1px solid ${theme.palette.divider}`
}));

export const MenuContainer = styled('div')('');

export const MenuList = styled('div', {
  shouldForwardProp: prop =>
    prop !== 'hasMenuHeader' && muiShouldOverrideProp(prop)
})(({ theme, hasMenuHeader }) => ({
  paddingTop: hasMenuHeader ? 0 : theme.spacing(1),
  paddingBottom: theme.spacing(1),
  WebkitOverflowScrolling: 'touch',
  boxSizing: 'border-box',
  maxHeight: 380,
  overflowY: 'overlay',
  '&::-webkit-scrollbar': {
    width: 0
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,.1)',
    borderRadius: 4
  },
  position: 'relative',
  '&:focus': {
    outline: 'none'
  },
  '&:hover, &:focus': {
    '&::-webkit-scrollbar': {
      width: 6
    }
  }
}));
